<template>
  <div class="svg25ar" ref="svgTarget">
    <svg
      height="550"
      preserveAspectRatio="xMidYMid meet"
      width="550"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="group1">
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="250"
          stroke="white"
          stroke-width="0.8"
        />
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="210"
          stroke="white"
          stroke-width="0.8"
        />
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="170"
          stroke="white"
          stroke-width="0.8"
        />
         <circle
          cx="275"
          cy="275"
          fill="black"
          r="130"
          stroke="white"
          stroke-width="0.8"
        />
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="90"
          stroke="white"
          stroke-width="0.8"
        />
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="50"
          stroke="white"
          stroke-width="0.8"
        />
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="22.5"
          stroke="white"
          stroke-width="0.8"
        />
        <line x1="25" y1="275" x2="150" y2="275" style="stroke:white;stroke-width:5"></line>
        <line x1="525" y1="275" x2="400" y2="275" style="stroke:white;stroke-width:5"></line>
        <text fill="white" font-size="10" stroke-width="0"  x="271" y="50">
          5
        </text>
        <text fill="white" font-size="10" stroke-width="0"  x="271" y="510">
          5
        </text>
        <text fill="white" font-size="10" stroke-width="0"  x="271" y="90">
          6
        </text>
        <text fill="white" font-size="10" stroke-width="0"  x="271" y="470">
          6
        </text>
        <text fill="white" font-size="10" stroke-width="0"  x="271" y="130">
          7
        </text>
        <text fill="white" font-size="10" stroke-width="0"  x="271" y="430">
          7
        </text>
        <text fill="white" font-size="10" stroke-width="0"  x="271" y="170">
          8
        </text>
        <text fill="white" font-size="10" stroke-width="0"  x="271" y="390">
          8
        </text>
        <text fill="white" font-size="10" stroke-width="0"  x="271" y="210">
          9
        </text>
        <text fill="white" font-size="10" stroke-width="0"  x="271" y="350">
          9
        </text>
      </g>
      <g v-for="(item, idx) in dataitem" :key="idx">
        <circle
          v-if="item.x != ''"
          :cx="centerPosition + item.x * 1"
          :cy="centerPosition - item.y * 1"
          :fill="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
          :r="bulletRadius"
          stroke="blank"
          stroke-width="0.8"
        />
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 子弹半径
      bulletRadius: 2.8,
      // 中心点
      centerPosition: 275,
      // 靶面直径（0环大小）
      diameter: 500,
      // 初始缩放比率
      initScale: 1,
      // 负margin值 考虑面板大于显示框的情况
      marign: 0,
      zoomSetting: [1,1,1,2.2,3.8,5.8]
    };
  },
  watch: {
    lastscore: {
      handler: function(newVal) {
        this.scaleZoom(newVal);
      },
      immediate: true
    }
  },
  methods: {
    // 设置css原始属性值（放大倍数scale ，偏移量 margin）
    setProperty: function(attribute, val) {
      this.$refs.svgTarget?this.$refs.svgTarget.style.setProperty(attribute, val):"";
    },
    scaleZoom: function(newVal) {
      let idx = 0;
      if (newVal == "") {
        idx = 0;
      } else {
        idx = Math.floor(newVal / 2);
      }

      this.setProperty("--transScale", this.initScale * this.zoomSetting[idx]);
    }
  },
  mounted() {
    const parentContainerHeight =
      document.getElementsByClassName("targetContainer")[0].clientHeight;
    // -0.1杜绝1像素问题
    this.initScale = parentContainerHeight / this.diameter-0.01;

    // 考虑面板大于显示框的情况
    if (parentContainerHeight < this.centerPosition * 2) {
      this.margin =
        (parentContainerHeight - this.centerPosition * 2) / 2 + "px";
      this.setProperty("--margin", this.margin);
      this.setProperty("--transScale", this.initScale);
    } else {
      this.setProperty("--transScale", this.initScale);
    }
    this.scaleZoom(this.lastscore);
  },
  props: ["dataitem", "lastscore"]
};
</script>
<style lang="less" scoped>
.svg25ar {
  flex: 1;
  display: flex;
  align-items: center;
  --transScale: 1;
  --margin: 0px;
  position: absolute;
  svg {
    transform: scale(var(--transScale));
    margin-top: var(--margin);
  }
}
</style>
